// moms-harness:anchor v2
// JIRA: LOGISPRD-14571
import type { PboTableColumn } from '@musinsa/pbo-core'
import { withPriceCells } from './PriceCell'
import { withBarcodeCell } from './BarcodeCell'

/**
 * 표가 쓰는 편집 셀 조립 — 단가 셀([withPriceCells])과 바코드 셀([withBarcodeCell])을 함께 끼운다.
 * 표(`SkuAttributeTable`)는 이 함수 하나만 부른다 — 둘 중 하나를 빠뜨리면 그 열이 읽기 전용이 되거나(단가)
 * 기존 행 바코드 입력칸이 되살아나므로(바코드), 조립을 한곳에 두고 테스트로 잠근다.
 */
export const withEditCells = (columns: PboTableColumn[], onChange: (rowKey: string, dataIndex: string, text: string) => void): PboTableColumn[] =>
  withBarcodeCell(withPriceCells(columns, onChange), onChange)
